import { LuDollarSign } from "react-icons/lu";
import { Button, Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useState } from "react";
import { TbCreditCardRefund } from "react-icons/tb";
import { BsBuildingCheck } from "react-icons/bs";
import { IoIosArrowRoundForward } from "react-icons/io";
import { ReactComponent as IndustryIcon } from '../../../Assets/images/icons/industry-icon.svg';
import { ReactComponent as EmailCheckIcon } from '../../../Assets/images/icons/email-check-icon.svg';
import { CiLock } from "react-icons/ci";
import { getTimeAgo } from "../../../Components/DateFn";
import { useDispatch } from "react-redux";
import { getScrapperStart } from "../../../Store/Slices/scrapperSlice";

const RecentSearchData = ({ recentSavedData, recentSearchedData, setSelectedtab,
    setIsInitial, currentPage, pageSize
}) => {
    const dispatch = useDispatch();
    let [key, setKey] = useState('recentSearch');
    // console.log('recent search:', recentSearchedData)

    const getFieldCount = (item) => {
        let count = 0;

        if (item?.contact_email_status_v2 && item?.contact_email_status_v2?.length > 0) count++;
        if (item?.organization_ids && item?.organization_ids?.length > 0) count++;
        if (item?.q_keywords && item?.q_keywords?.trim() !== "") count++;
        if (item?.person_titles && item?.person_titles?.length > 0) count++;
        if (item?.person_locations && item?.person_locations?.length > 0) count++;
        if (item?.q_organization_keyword_tags && item?.q_organization_keyword_tags?.length > 0) count++;

        return count === 0 ? 'No' : count;
    };

    const getFilledValues = (item) => {
        // const fieldsToCheck = {
        //     organization_ids: item.organization_ids,
        //     q_keywords: item.q_keywords,
        //     person_titles: item.person_titles,
        //     person_locations: item.person_locations,
        //     q_organization_keyword_tags: item.q_organization_keyword_tags,
        // };

        const fieldsToCheck = {
            "Company": item?.organization_names,
            "Name": item?.q_keywords,
            "Job Titles": item?.person_titles,
            "Locations": item?.person_locations,
            "Industry": item?.q_organization_keyword_tags,
            "Email Status": item?.contact_email_status_v2
        };

        let results = [];
        for (let [key, value] of Object.entries(fieldsToCheck)) {
            if (Array.isArray(value) && value.length > 0) {
                results.push(`${key}: ${value.join(", ")}`);
            } else if (typeof value === "string" && value.trim() !== "") {
                results.push(`${key}: ${value}`);
            }
        }
        return results;
    };

    const removeKeys = (obj, keysToRemove) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
    };

    const handleSearch = (data) => {
        // debugger
        // let orgIds = data?.organization_ids
        // let orglocations = data?.person_locations
        // let orgEmailStatus = data?.contact_email_status_v2
        // let orgPersonTitle = data?.person_titles
        // // let orgIndutries = data?.keywords
        // let orgIndutries = data?.q_organization_keyword_tags

        // const keysToDelete = ["organization_ids", "person_locations", "contact_email_status_v2",
        //     "person_titles", "q_organization_keyword_tags", "keywords"
        // ];
        // const updated = removeKeys(data, keysToDelete);
        // debugger
        // const { organization_ids, ...newObj } = data;
        //        **
        //         updated['organization_ids'] = data?.organization_ids
        //         updated['person_locations'] = data?.person_locations
        //         updated['contact_email_status_v2'] = data?.contact_email_status_v2
        //         updated['person_titles'] = data?.person_titles
        //         // updated['keywords'] = orgIndutries?.map((x) => x.value)
        //         updated['q_organization_keyword_tags'] = data?.q_organization_keyword_tags
        //         updated['page'] = currentPage
        //         updated['per_page'] = pageSize
        //         updated['organization_names'] = data?.organization_names
        // **
        let obj = {
            "contact_email_status_v2": data?.contact_email_status_v2,
            "fields": ["email", "first_name", "last_name", "phone_numbers"],
            "q_keywords": data?.q_keywords,
            "person_titles": data?.person_titles,
            "organization_domains": data?.organization_domains,
            "person_locations": data?.person_locations,
            "include_similar_titles": true,
            "organization_ids": data?.organization_ids,
            "q_organization_keyword_tags": data?.q_organization_keyword_tags,
            "organization_num_employees_ranges": data?.organization_num_employees_ranges,
            "name_search": "",
            "organization_names": data?.organization_names,
            "page": currentPage,
            "per_page": pageSize
        }
        setIsInitial(false);
        // console.log('PAYLOAD TO RECENT SEARCH:', obj)
        dispatch(getScrapperStart(obj))
    }

    return (<>
        <Row className="justify-content-center align-items-center">
            <Col xs={12} md={9} lg={8} className="p-0">
                <Card className="mb-3 p-0">
                    <Card.Body>
                        <Tab.Container id="recent-pill-tab" defaultActiveKey={key} onSelect={(k) => setKey(k)}>
                            <Nav variant="pills" className='d-inline-flex rounded-2 border border-opacity-50 p-1 mb-2'>
                                <Nav.Item>
                                    <Nav.Link eventKey="recentSearch"
                                        className={`py-1 ${key === 'recentSearch' ? 'text-bg-dark' : 'bg-light text-body'}`}>
                                        <span>Recently Searched</span>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="recentSaved"
                                        className={`py-1 ${key === 'recentSaved' ? 'text-bg-dark' : 'bg-light text-body'}`}>
                                        <span>Recently Saved</span>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey="recentSearch">
                                    {/* <div className="my-3 fs-6 fw-medium text-center text-secondary">No record found.</div> */}
                                    <div className="vstack gap-2">
                                        {recentSearchedData?.length ?
                                            <>{recentSearchedData
                                                .slice()
                                                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                                .map((x) => (
                                                    <Card className="py-2 px-3 hstack shadow-hover" role="button" onClick={() => handleSearch(x?.searchData || x)}>
                                                        <div className="vstack flex-fill">
                                                            <div className="hstack">
                                                                <span>{getFieldCount(x?.searchData || x)} Filter(s)</span> <span className="text-secondary"> . {getTimeAgo(x?.updatedAt)}</span>
                                                            </div>
                                                            <div className="hstack gap-2">
                                                                {getFilledValues(x?.searchData || x).map((val, idx) => (
                                                                    <span
                                                                        key={idx}
                                                                        className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-1 mb-1"
                                                                    >
                                                                        {val}
                                                                    </span>
                                                                ))}
                                                                {/* <div className="hstack gap-1">
                                                                <IndustryIcon width={16} height={16} />
                                                                <span className="text-secondary">Industry & Keywords:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                            </div>
                                                            <div className="hstack gap-1">
                                                                <IndustryIcon width={16} height={16} />
                                                                <span className="text-secondary">Industry & Keywords:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                            </div>
                                                            <div className="hstack gap-1">
                                                                <EmailCheckIcon width={16} height={16} />
                                                                <span className="text-secondary">Email Status:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Verified</span>
                                                            </div> */}
                                                            </div>
                                                        </div>
                                                        <div role="button" className="icon-link icon-link-hover fs-4"><IoIosArrowRoundForward size={20} className="bi" /></div>
                                                    </Card>
                                                ))}
                                                {/* <Card className="py-2 px-3 hstack shadow-hover" role="button">
                                                    <div className="vstack flex-fill">
                                                        <div className="hstack">
                                                            <span>3 Filters</span> <span className="text-secondary"> . 4 hrs ago</span>
                                                        </div>
                                                        <div className="hstack gap-2">
                                                            <div className="hstack gap-1">
                                                                <IndustryIcon width={16} height={16} />
                                                                <span className="text-secondary">Industry & Keywords:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                            </div>
                                                            <div className="hstack gap-1">
                                                                <IndustryIcon width={16} height={16} />
                                                                <span className="text-secondary">Industry & Keywords:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                            </div>
                                                            <div className="hstack gap-1">
                                                                <EmailCheckIcon width={16} height={16} />
                                                                <span className="text-secondary">Email Status:</span>
                                                                <span className="text-truncate" style={{ maxWidth: 20 }}>Verified</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div role="button" className="icon-link icon-link-hover fs-4"><IoIosArrowRoundForward size={20} className="bi" /></div>
                                                </Card> */}
                                            </>
                                            :
                                            <div className="my-3 fs-6 fw-medium text-center text-secondary">No record found.</div>
                                        }
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="recentSaved">
                                    <div className="vstack gap-2">
                                        {recentSavedData?.length ?
                                            <>
                                                {recentSavedData
                                                    .slice()
                                                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                                    .map((data, i) => (
                                                        <Card className="py-2 px-3 hstack shadow-hover" role="button" onClick={() => setSelectedtab('saved')}>
                                                            <div className="vstack flex-fill">
                                                                <div className="hstack">
                                                                    <span>{data?.first_name + ' ' + data?.last_name}</span>
                                                                </div>
                                                                <div className="hstack">
                                                                    <span>{data?.organization?.name}</span>
                                                                    <span className="text-secondary"> . {getTimeAgo(data?.updatedAt)}</span>
                                                                </div>
                                                                {/* <div className="hstack gap-2">
                                                    <div className="hstack gap-1">
                                                        <IndustryIcon width={16} height={16} />
                                                        <span className="text-secondary">Industry & Keywords:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                    </div>
                                                    <div className="hstack gap-1">
                                                        <IndustryIcon width={16} height={16} />
                                                        <span className="text-secondary">Industry & Keywords:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                    </div>
                                                    <div className="hstack gap-1">
                                                        <EmailCheckIcon width={16} height={16} />
                                                        <span className="text-secondary">Email Status:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Verified</span>
                                                    </div>
                                                </div> */}
                                                            </div>
                                                            <div role="button" className="icon-link icon-link-hover fs-4"><IoIosArrowRoundForward size={20} className="bi" /></div>
                                                        </Card>
                                                    ))}
                                            </>
                                            :
                                            <div className="my-3 fs-6 fw-medium text-center text-secondary">No record found.</div>
                                        }
                                        {/* <Card className="py-2 px-3 hstack shadow-hover" role="button">
                                            <div className="vstack flex-fill">
                                                <div className="hstack">
                                                    <span>3 Filters</span> <span className="text-secondary"> . 4 hrs ago</span>
                                                </div>
                                                <div className="hstack gap-2">
                                                    <div className="hstack gap-1">
                                                        <IndustryIcon width={16} height={16} />
                                                        <span className="text-secondary">Industry & Keywords:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                    </div>
                                                    <div className="hstack gap-1">
                                                        <IndustryIcon width={16} height={16} />
                                                        <span className="text-secondary">Industry & Keywords:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Industry</span>
                                                    </div>
                                                    <div className="hstack gap-1">
                                                        <EmailCheckIcon width={16} height={16} />
                                                        <span className="text-secondary">Email Status:</span>
                                                        <span className="text-truncate" style={{ maxWidth: 20 }}>Verified</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="button" className="icon-link icon-link-hover fs-4"><IoIosArrowRoundForward size={20} className="bi" /></div>
                                        </Card> */}
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Card.Body>
                    <Card.Footer className="d-none">
                        <div className="d-flex justify-content-between">
                            <div className="hstack gap-2 align-items-center">
                                <span className="hstack p-2 w-30px h-30px bg-secondary-subtle rounded-2"><CiLock /></span>
                                <span>Unlock advanced filters:</span>
                                <span className="hstack"><LuDollarSign className="me-2" /> Revenue</span>
                                <span className="hstack"><TbCreditCardRefund className="me-2" />Funding</span>
                                <span className="hstack"><BsBuildingCheck className="me-2" />Company Lookalikes</span>
                            </div>
                            <Button variant="primary">View plans</Button>
                        </div>
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    </>)
}
export default RecentSearchData;